import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  items:{

  }
}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {
  LOADING_RENTED_GOODS (state, isLoading){
    state.status.loading = isLoading
  },

  SET_RENTED_GOODS (state, data){
    state.items = data
  }
}

//async methods  store.dispatch('increment')
const actions = {


  loadRentedGoods ({state, commit}) {

    commit('LOADING_RENTED_GOODS', true);

    return api.get('rentedgoods')
      .then(function (response) {
        commit('SET_RENTED_GOODS', response.data.data)

        commit('LOADING_RENTED_GOODS', false);
      })
      .catch(function (error) {
        commit('LOADING_RENTED_GOODS', false);

      });
  }

}


export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/RentedGoodsStore.js